/**
 * WordPress Data Store for TopBuddy Display Rules
 * 
 * Manages display rules state for notification bars
 * 
 * @package TopBuddy
 */

import { createReduxStore, register } from '@wordpress/data';

const STORE_NAME = 'topbuddy/displayRules';

const DEFAULT_STATE = {
	rules: {},
	// Advanced Display Rules (Pro)
	referrer_enabled: false,
	referrer_url: '',
	query_params_enabled: false,
	query_params: [], // [{name: 'utm_source', value: 'facebook'}]
	page_views_enabled: false,
	page_views_operator: 'greater_than',
	page_views_count: 1,
	time_on_site_enabled: false,
	time_on_site_seconds: 30,
	cookie_enabled: false,
	cookie_name: '',
	cookie_value: '',
};

const actions = {
	setDisplayRules(rules) {
		return {
			type: 'SET_DISPLAY_RULES',
			rules,
		};
	},
	updateDisplayRule(key, value) {
		return {
			type: 'UPDATE_DISPLAY_RULE',
			key,
			value,
		};
	},
};

const reducer = (state = DEFAULT_STATE, action) => {
	switch (action.type) {
		case 'SET_DISPLAY_RULES':
			return {
				...state,
				rules: action.rules,
			};
		case 'UPDATE_DISPLAY_RULE':
			return {
				...state,
				rules: {
					...state.rules,
					[action.key]: action.value,
				},
			};
		default:
			return state;
	}
};

const selectors = {
	getDisplayRules(state) {
		return state.rules;
	},
	getDisplayRule: (state) => (key) => {
		return state.rules[key] || null;
	},
};

const store = createReduxStore(STORE_NAME, {
	reducer,
	actions,
	selectors,
});

// Only register if not already registered
if (!window.wp.data.select(STORE_NAME)) {
	register(store);
}

export default store;
